import React, { memo } from 'react'
import { useLazyEffect } from '../../../../../../../utils/hooks'

import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { getLeftHipState } from '../../../../../store/selectors'

import { FormGroup, Checkbox, FormLabel } from '../../../../../../../components'
import { deepCopy } from '../../../../../../../utils/fns'

const DuplicateInputs = (props) => {
  const { isDuplicate, onChange } = props
  const leftHip = useSelector(getLeftHipState)

  const handleDuplicate = (e) => {
    const { name, checked } = e.target

    return onChange({ [name]: checked })
  }

  useLazyEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const { angle, memberID, ...rest } = leftHip

    const copiedData = deepCopy(rest)

    if (isDuplicate) {
      onChange(copiedData)
    }
  }, [leftHip, isDuplicate])

  return (
    <FormGroup>
      <FormLabel>Duplicate Inputs</FormLabel>
      <Checkbox
        label="Same inputs as Left Hip"
        name="isDuplicate"
        checked={isDuplicate}
        onChange={handleDuplicate}
        data-ga4={`rightHip_isDuplicate:${isDuplicate}`}
        data-testid="isDuplicate"
      />
    </FormGroup>
  )
}

DuplicateInputs.propTypes = {
  isDuplicate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default memo(DuplicateInputs)
